import { Fragment, useState } from "react";
import { Box, IconButton, Stack } from "@mui/material";
import "./mandate.scss";
import User from "../../Components/Mandate/User/User";
import Container from "@mui/material/Container";
import AllMandate from "../../Components/Mandate/Page/AllMandate";
import TabMandate from "../../Components/Mandate/Page/TabMandate";
import ChangeLanguage from "../../Layout/ChangeLanguage";
import LogoutIcon from '@mui/icons-material/Logout';
import LogoutMenu from "../../Layout/LogoutMenu";
export default function Mandate() {
  const [value, setValue] = useState("AllMandate");


  // ================== Function open logout ===================
  const [oepnLogout, setOpenLogout] = useState(false);
  const handleOpenLogout = () => setOpenLogout(true);
  const handleCloseLogout = () => setOpenLogout(false);



  return (
    <Fragment>
      <Box sx={{ position: "relative" }}>
        <Box sx={{ position: "absolute", top: 20, right: 30 }}>
          <Stack direction="row" alignItems="center" spacing={1} >
            <ChangeLanguage />
            <IconButton onClick={handleOpenLogout}>
              <LogoutIcon sx={{ color: "red" }} />
            </IconButton>
            <LogoutMenu open={oepnLogout} handleClose={handleCloseLogout} />
          </Stack>
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        sx={{ paddingY: 4, height: "100vh" }}
        className="mandate-container"
      >
        <TabMandate value={value} setValue={setValue} />
        {value === "AllMandate" ? <AllMandate /> : null}
        {value === "User" ? <User /> : null}
      </Container>
    </Fragment>
  );
}
